import { useMemo } from "react"
import { Card, Button, Space } from "antd"
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons"
import StudentTable from "./components/StudentTable"
import StudentModal from "./components/StudentModal"
import { useCrud } from "@/hooks/useCrud"
import { Student, StudentFormData } from "./types"
import studentApi from "./api"
import { ID } from "@/types/common"

const StudentManagement = () => {
  const api = useMemo(
    () => ({
      getList: (params?: { page?: number; pageSize?: number }) =>
        studentApi.getList(params),
      create: studentApi.create,
      update: (id: ID, data: StudentFormData | Partial<StudentFormData>) =>
        studentApi.update(id, data as StudentFormData),
      delete: studentApi.delete,
    }),
    []
  )

  const {
    items: students,
    loading,
    opLoading,
    isModalOpen,
    editingItem: editingStudent,
    selectedIds,
    setSelectedIds,
    pagination,
    handleAdd,
    handleEdit,
    handleSave,
    handleDelete,
    handleBatchDelete,
    handleCloseModal,
    handlePageChange,
  } = useCrud<Student, StudentFormData>({
    api,
    entityName: "学生",
    pagination: {
      enabled: true,
      pageSize: 10,
    },
  })
  // 计算统计数据
  const totalStudents = pagination.total
  const selectedCount = selectedIds.length
  const batchDisabled = selectedCount === 0
  return (
    <div className="p-6">
      {/* 主要内容区域 */}
      <Card>
        {/* 操作栏 */}
        <div className="flex justify-between items-center mb-4">
          <div>
            <span className="text-gray-500">共 {totalStudents} 名学生</span>
          </div>
          <Space>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAdd}
              loading={opLoading}
              data-testid="btn-add-student"
            >
              新增学生
            </Button>
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={handleBatchDelete}
              disabled={batchDisabled}
              loading={opLoading}
              data-testid="btn-batch-delete"
            >
              批量删除 {selectedCount > 0 && `(${selectedCount})`}
            </Button>
          </Space>
        </div>

        {/* 学生表格 */}
        <StudentTable
          students={students}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={loading}
          selectedIds={selectedIds}
          onSelectionChange={setSelectedIds}
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onPageChange={handlePageChange}
        />
      </Card>

      {/* 学生信息模态框 */}
      <StudentModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSave}
        student={editingStudent}
        loading={opLoading}
      />
    </div>
  )
}

export default StudentManagement
